module.exports = __webpack_public_path__ + "img/sideBar.c2662288.svg";